<!-- This is in /Common, but is currently only used by document processing.  -->
<!-- It is not general enough for actual quick search -->
<div tabindex="0" style="height: 72vh;">
    @if (results.length > 0) {
        <div class="search-scroll"
             infiniteScroll
             (infiniteScrollNext)="getResults()"
             infiniteScrollTargetClass="list-group-item">
            <div class="list-group"
                 style="border-bottom: 1px solid lightgray;">
                @for (result of results; track result; let i = $index) {
                    <span (click)="resultClicked(result)"
                          [ngStyle]="{ 'min-height': result.status !== 'Active' ? '70px' : '30px', 'background-color': result.hasIntakeItems ? '#e0e0e0' : 'white'}"
                          (mouseover)="hoverIn(i)" class="list-group-item clickable search-result-{{i}}"
                          tabindex="0"
                          (keyup)="keyup($event, i)"
                          style="border: initial; border-top: 1px solid var(--ace-neutral-200);">

                        @switch (resultType) {
                            @case ('parcel') {
                                <search-result-parcel [result]="result"></search-result-parcel>
                            }
                            @case ('taxBill') {
                                <search-result-parcel [result]="result" [childEntity]="'taxBill'"></search-result-parcel>
                            }
                            @case ('refund') {
                                <search-result-parcel [result]="result" [childEntity]="'refund'"></search-result-parcel>
                            }
                            @case ('assessment') {
                                <search-result-parcel [result]="result" [childEntity]="'assessment'"></search-result-parcel>
                            }
                            @case ('appeal') {
                                <search-result-parcel [result]="result" [childEntity]="'appeal'"></search-result-parcel>
                            }
                            @case ('filing') {
                                <search-result-parcel [result]="result" [childEntity]="'filing'"></search-result-parcel>
                            }
                            @case ('company') {
                                <search-result-company [result]="result"></search-result-company>
                            }
                            @case ('site') {
                                <search-result-site [result]="result"></search-result-site>
                            }
                        }
                        @for (extraFilter of extraFilters | sortBy: 'sequenceNum'; track extraFilter) {
                            <p class="list-group-item-text">
                                <search-result-extra [result]="result" [filter]="extraFilter"></search-result-extra>
                            </p>
                        }
                        @if (result.readyLine) {
                            <p class="list-group-item-text">{{result.readyLine}}</p>
                        }
                        @if (result.hasIntakeItems) {
                            <p class="list=-group-item-text" style="color:red;">Pending Documents</p>
                        }
                    </span>
                }
            </div>
        </div>
    }
    @if (results && results.length === 0 && !loading) {
        <p class="lead">No Results Found</p>
    }
    @if(loading) {
        <ws-ace-loader></ws-ace-loader>
    }
</div>

